import { useEffect, useState } from "react";

import { App as GameWorld } from "./app.js";
import { AuthScreen } from "./auth-screen.js";
import { getSession, logout, type SessionUser } from "./gordonland-api.js";
import { VoicePanel } from "./voice-panel.js";

export function GordonLandRoot() {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [failure, setFailure] = useState("");

  useEffect(() => {
    let cancelled = false;
    void getSession().then((account) => {
      if (!cancelled) setUser(account);
    }).catch((error: unknown) => {
      if (!cancelled) setFailure(error instanceof Error ? error.message : "无法连接认证服务");
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (user === null) return;
    const timer = window.setInterval(() => { void getSession(); }, 60_000);
    return () => window.clearInterval(timer);
  }, [user]);

  if (loading) return <main className="auth-shell"><p className="auth-loading">正在连接 GordonLand…</p></main>;
  if (user === null) return <><AuthScreen onAuthenticated={(account) => { setFailure(""); setUser(account); }} />{failure !== "" ? <p className="root-failure" role="alert">{failure}</p> : null}</>;

  return (
    <>
      <GameWorld />
      <div className="account-chip">
        <span><strong>{user.nickname}</strong>{user.role === "owner" ? <em>所有者</em> : null}</span>
        <button type="button" onClick={() => {
          void logout().finally(() => setUser(null));
        }}>退出</button>
      </div>
      <VoicePanel user={user} />
    </>
  );
}
